import { createSlice } from "@reduxjs/toolkit";
import Imagge1 from "../../assets/Anh1.jpg";
const initialState = {
  items: [
    {
      id: 1,
      title:
        "Họp mặt đồng hương 2 tỉnh Bạc Liêu và Cà Mau tại TP. Cần Thơ nhân dịp Xuân Giáp Thìn 2024",
      description:
        "Sáng 27/1, tại TP. Cần Thơ, Tỉnh ủy, HĐND, UBND, Ủy ban MTTQ Việt Nam",
      image: Imagge1,
      category: "Tin báo chí",
      date: "27/1/2024",
      images: [
        {
          url: Imagge1,
          caption:
            "Họp mặt đồng hương 2 tỉnh Bạc Liêu và Cà Mau tại TP. Cần Thơ nhân dịp Xuân Giáp Thìn 2024",
        },
      ],
    },
    {
      id: 2,
      title: "BCCU ĐẾN THĂM CÔNG TY TNHH DV TM XÂY DỰNG ĐỨA ÔC TUẤN DUY",
      description: "Thăm và chúc tết công ty thành viên CLB",
      image: Imagge1,
      category: "Tin hoạt động",
      images: [
        {
          url: "/api/placeholder/400/300",
          caption: "Thăm công ty thành viên",
        },
      ],
    },
    {
      id: 3,
      title: "BCCU ĐẾN THĂM CƠ SỞ KINH DOANH HỮU MIẾU MỘC GỖ",
      description: "Đoàn BCCU thăm và chúc tết cơ sở kinh doanh",
      image: Imagge1,
      category: "Tin hoạt động",
      images: [
        {
          url: "/api/placeholder/400/300",
          caption: "Thăm cơ sở kinh doanh",
        },
      ],
    },
  ],
  loading: false,
};

const newsSliceOther = createSlice({
  name: "newsother",
  initialState,
  reducers: {
    setNewsOther: (state, action) => {
      state.items = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setNewsOther, setLoading } = newsSliceOther.actions;
export default newsSliceOther.reducer;
